var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5000 5000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002868;}.cls-2{fill:#ef2b2d;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.9,2774.46c11.11,101.86,28.41,202.67,51.88,302.06H1011.92v1434.03c93.8,69.43,192.55,132.33,295.57,188.14v-1924.23H14.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1862.61,4918.09c79.1,20.73,159.67,37.72,241.49,50.74,15.62,2.49,31.31,4.82,47.04,7.02v-1902.56h2782.81c23.08-98.34,40.14-198.07,51.14-298.81H1862.61v2143.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1862.61,81.92c-195.04,51.13-381.16,125.18-555.12,219.45v1922.2H15.12C5.08,2314.96,0,2407.19,0,2500s5,183.72,14.9,274.46H1307.49v1924.23c173.94,94.24,360.07,168.27,555.12,219.4V2774.46h3122.48c9.9-90.74,14.91-182.32,14.91-274.46s-5.08-185.04-15.12-276.42H1862.61V81.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1307.49,301.38c-103.02,55.83-201.77,118.74-295.57,188.18V1928.01H65.74c-22.78,97.29-39.67,195.92-50.62,295.57H1307.49V301.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2151.14,1924.77V24.17c-15.72,2.19-31.4,4.53-47.04,7.01-81.82,13.02-162.38,30.01-241.49,50.75V2223.58h3122.27c-11.07-100.75-28.21-200.48-51.38-298.81H2151.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1011.92,489.55C618.5,780.79,312.05,1186.78,142.52,1665.91c-30.45,86.07-56.04,173.53-76.78,262.1H1011.92V489.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.78,3076.52c20.33,86.11,45.27,171.16,74.79,254.9,169.35,480.38,476.16,887.36,870.35,1179.13v-1434.03H66.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4933.5,1924.77c-20.61-87.46-45.95-173.83-76.04-258.85C4504.93,669.48,3557.52,0,2500,0,2383.26,0,2266.14,8.13,2151.14,24.17V1924.77h2782.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2151.14,4975.84c73.27,10.22,147.61,17.28,221.61,20.99,42.28,2.11,85.09,3.18,127.25,3.18s84.96-1.06,127.25-3.18c1016.68-50.96,1892.47-704.68,2231.16-1665.41,29.89-84.79,55.07-170.93,75.54-258.14H2151.14v1902.56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.69ca5511ec70836b3ed40205556eb211.svg";
export { ForwardRef as ReactComponent };